import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpClient
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { AuthenticationService } from '../authentication/authentication.service';
import { environment } from '../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from '../../shared/alert/alert.service';
import { LoadingOverlayService } from 'src/app/shared/loading-overlay/loading-overlay.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    isRefreshingToken = false;
    constructor(
        private authenticationService: AuthenticationService,
        private loadingOverlayService: LoadingOverlayService,
        private http: HttpClient,
        private route: ActivatedRoute,
        private router: Router,
        private alertService: AlertService
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError(err => {
                if (err.status === 401 && !this.isRefreshingToken) {
                    const rememberMeToken = localStorage.getItem('rememberMeToken');
                    if (rememberMeToken) {
                        this.isRefreshingToken = true;
                        //hit api to refresh token
                        this.http
                            .get<any>(`${environment.apiUrl}/auth/refresh-token/${rememberMeToken}`)
                            .pipe(
                                map(res => {
                                    this.authenticationService.setTokens(res);
                                })
                            )
                            .subscribe({
                                next: () => {
                                    // get return url from route parameters or default to '/'
                                    const returnUrl =
                                        this.route.snapshot.queryParams['returnUrl'] ||
                                        '/dashboard';
                                    this.router.navigate([returnUrl]);
                                    this.isRefreshingToken = false;
                                    location.reload();
                                },
                                error: () => {
                                    // The session could not be renewed. Say so before logging out:
                                    // the reload below tears the page down, so the toast needs a
                                    // moment on screen or the client is bounced to the login page
                                    // with no explanation at all.
                                    this.alertService.error(
                                        'Your session has expired. Please sign in again.');
                                    this.isRefreshingToken = false;
                                    setTimeout(() => {
                                        this.authenticationService.logout();
                                        location.reload();
                                    }, 2500);
                                }
                            });
                    } else {
                        // auto logout if 401 response returned from api
                        this.authenticationService.logout();
                        location.reload();
                    }
                }

                if (err.status === 504) {
                    this.loadingOverlayService.hide();
                }

                if (err.error && err.error.errors && Array.isArray(err.error.errors)) {
                    // PHP upload endpoint format - pass full object
                    return throwError(err.error.errors);
                } else {
                    // SpringBoot errors. Without a message from the API (network failure, proxy
                    // timeout, an HTML error page) show a plain sentence, not "OK" / "Unknown Error".
                    const error = err.error?.message || 'Something went wrong. Please try again.';
                    return throwError(error);
                }
            })
        );
    }
}
